import { get } from 'lodash-es';
import { getApiClientErrorBody } from '@/services/api/errors';
import { isBlocklistBlock } from '@/utils/blocklist';

const GENERIC_START_SIGNUP_ERROR = 'Sign up failed. Try again or contact support if the issue continues.';

const EMAIL_POINTER = '/data/attributes/email';

/**
 * The blocklist explanation one entry carries, or `undefined`. Read through
 * `get` so a malformed entry can't throw inside the entry step's `catch`, which
 * would leave the visitor with no snackbar at all.
 */
function blocklistEmailDetail(entry: unknown): string | undefined {
  const pointer: unknown = get(entry, 'source.pointer');
  if (pointer !== EMAIL_POINTER) {
    return undefined;
  }
  const detail: unknown = get(entry, 'detail');
  return typeof detail === 'string' && isBlocklistBlock(detail) ? detail : undefined;
}

/**
 * Map a failed `account_signup/start` to user-facing copy.
 *
 * The one branch that matters is the domain blocklist: the server explains
 * *why* the address was rejected (Spamhaus DBL or SURBL), and that detail is
 * worth surfacing verbatim — the generic copy would send someone retrying an
 * address that can never work. Everything else stays generic; `start` failures
 * are otherwise vetting/rate-limit noise with no useful public wording.
 */
export function resolveStartSignupErrorMessage(error: unknown): string {
  const errors: unknown = get(getApiClientErrorBody(error), 'errors');
  if (!Array.isArray(errors)) {
    return GENERIC_START_SIGNUP_ERROR;
  }

  const details: Array<string | undefined> = errors.map(blocklistEmailDetail);
  return details.find((detail) => detail != null) ?? GENERIC_START_SIGNUP_ERROR;
}
